import React, { ReactNode } from 'react';
import { Translate } from 'react-redux-i18n';
import Button from '../Button';
import ConfirmationModal from './ConfirmationModal';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  noFill?: boolean;
  noVerticalMargin?: boolean
  withHeader?: boolean
  children?: ReactNode
  withCancelConfirmation?: boolean
};

type State = {
  isDrawerDirty: boolean
  isModalOpen: boolean
  I18nKeys: {
    title: string
    subtitle: string
  };
};

class Drawer extends React.PureComponent<Props, State> {
  state: State = {
    isDrawerDirty: false,
    isModalOpen: false,
    I18nKeys: {
      title: '',
      subtitle: '',
    },
  };

  componentDidMount(): void {
    document.getElementsByClassName('mon-compte-header')[0].nextElementSibling.classList.add('noscroll');
  }

  componentWillUnmount(): void {
    document.getElementsByClassName('mon-compte-header')[0].nextElementSibling.classList.remove('noscroll');
  }

  toggleModal = (): void => {
    this.setState((prevState) => ({ isModalOpen: !prevState.isModalOpen }));
  };

  setDirty = (dirty: boolean, callback: () => void): void => {
    this.setState({ isDrawerDirty: dirty }, () => {
      if (callback) callback();
    });
  };

  closeDrawer = (): void => {
    if (this.state.isDrawerDirty) {
      this.toggleModal();
    } else {
      this.props.onClose();
    }
  };

  setModalI18n = (title: string, subtitle: string): void => {
    this.setState({
      I18nKeys: {
        title,
        subtitle,
      },
    });
  };

  backButton: ReactNode = (
    <Button
      type="back"
      buttonType="button"
      onClick={this.closeDrawer}
    >
      <i className="fa fa-angle-left fa-2x" />
      <Translate value="actions.BACK" />
    </Button>
  );

  render(): ReactNode {
    let child = this.props.children[0] || this.props.children;
    if (this.props.withCancelConfirmation) {
      child = React.cloneElement(child, {
        onClose: this.closeDrawer,
        setDirty: this.setDirty,
        setModalI18n: this.setModalI18n,
      });
    }
    return (
      <div
        onClick={this.closeDrawer}
        className={`modal-background ${this.props.isOpen ? 'show' : ''}`}
      >
        <div>
          <ConfirmationModal
            isOpen={this.state.isModalOpen}
            onClose={this.toggleModal}
            cancelButtonI18nKey="HOME.CONFIRM_MODAL_CANCEL"
            confirmationButtonI18nKey="HOME.CONFIRM_MODAL_CONFIRM"
            titleI18nKey={this.state.I18nKeys.title}
            subtTitleI18nKey={this.state.I18nKeys.subtitle}
            onConfirm={() => {
              this.setDirty(false, this.props.onClose);
            }}
            confirmeDisabled={false}
            small
          />
          <div className="drawer" onClick={(e) => e.stopPropagation()}>
            <div className="back-button-container">
              {this.backButton}
            </div>
            <div
              className={`drawer-content ${this.props.noFill ? ' large' : ''}${this.props.withHeader ? ' with-header' : ''}`}
            >
              {child}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Drawer;
